// Shared sale-price helpers so every page computes discounts the same way

export const hasSale = (product) =>
  !!product && Number(product.salePercentage) > 0 && Number(product.salePercentage) <= 100;

export const getSalePrice = (product) => {
  const price = Number(product?.price) || 0;
  if (!hasSale(product)) return price;
  const pct = Number(product.salePercentage);
  return Math.round((price - (price * pct) / 100) * 100) / 100;
};

export const getSavingsAmount = (product) => {
  const price = Number(product?.price) || 0;
  return Math.round((price - getSalePrice(product)) * 100) / 100;
};

// Returns a copy of the product with `price` set to the effective (sale) price,
// so cart totals and checkout always charge what the customer was shown.
export const withEffectivePrice = (product) => {
  if (!hasSale(product)) return product;
  return { ...product, price: getSalePrice(product), originalPrice: product.price };
};
